import { useState, useEffect, useCallback } from 'react';
import { onSnapshot } from 'firebase/firestore';

const useFirestoreQuery = (query) => {
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    const executeQuery = useCallback(() => {
        if (!query) {
            setData([]);
            setIsLoading(false);
            return () => { };
        }

        setIsLoading(true);
        const unsubscribe = onSnapshot(query,
            (snapshot) => {
                const docs = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setData(docs);
                setIsLoading(false);
            },
            (err) => {
                console.error("Firestore query error:", err);
                setError(err);
                setIsLoading(false);
            }
        );
        return () => unsubscribe();
    }, [JSON.stringify(query)]);

    useEffect(() => {
        const unsubscribe = executeQuery();
        return () => unsubscribe();
    }, [executeQuery]);

    return { data, isLoading, error };
};

export default useFirestoreQuery;